var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-mit-menu-footer"},[_c('v-list',{attrs:{"dense":""}},[(_vm.userModel)?_c('v-list-item',{on:{"click":function($event){return _vm.logout()}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-logout")])],1),_c('v-list-item-title',[_vm._v("Sign out")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }